import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Heading } from '../heading';
import { Text } from '../text';

function CircularProgressBar({ totalBins, filledBinsCount }) {
  const percentage = (filledBinsCount / totalBins) * 100;

  const getHue = (percentage) => {
    return percentage * 1.2; // Multiply by a factor to get a hue value between 0 and 120 (for green to red)
  };

  return (
    <div style={{ width: '200px', height: '200px', position: 'relative' }}>
      <CircularProgressbar
        value={percentage}
        styles={buildStyles({
          pathColor: `hsl(${getHue(percentage)}, 100%, 50%)`,
        })}
      />
      <div className="flex flex-col items-center justify-center w-max h-max gap-1.5 left-0 bottom-0 right-0 top-0 m-auto absolute">
        <Heading as="h6" className="!text-gray-900 text-center">
          {totalBins}
        </Heading>
        <Text size="s" as="p" className="!text-black-900_87 opacity-0.5">
          Total Bins
        </Text>
      </div>
    </div>
  );
}

export default CircularProgressBar;
